import { Route, Switch } from "react-router-dom";
import ConciliacaoBancariaListagemPage from "./Listagem";
import ConciliacaoBancariaItensProcessadosPage from "./ItensProcessados";

function RetornoBancarioPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/retorno-bancario"
        component={ConciliacaoBancariaListagemPage}
      />
      <Route
        exact
        path="/financeiro/retorno-bancario/:dataInicio/:dataFim/:id?"
        component={ConciliacaoBancariaItensProcessadosPage}
      />
    </Switch>
  );
}

export default RetornoBancarioPages;
